import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import Vue from "vue";

export default Vue.extend({
  name: "area-mixin",
  computed: {
    selectedTopPlaceMixin(): PortalAdapterApi.TopArea | undefined {
      return this.$store.state.data.selectedTopPlace;
    },
    hasSelectedAreaNameMixin(): boolean {
      // 現在地 & default & search on map
      return (
        this.selectedTopPlaceMixin?.areaName !== "current-place" &&
        this.selectedTopPlaceMixin?.areaName !== "Default" &&
        this.selectedTopPlaceMixin?.areaName !== ""
      );
    },
  },
});
